import randomHashGenerator from "../helpers/randomHashGenerator";
const SESSION = "session-";
const UPDATES = "updates";
const WARNINGS = "warnings";
export const sessionTitleUrlBuilder = (sessionId) => {
    return SESSION + sessionId;
};
export const updateInstanceUrlBuilder = (sessionId, updateType) => {
    const updateId = randomHashGenerator(10);
    return SESSION + sessionId + "/" + UPDATES + "/" + updateType + "-" + updateId;
};
export const warningInstanceUrlBuilder = (sessionId, warningTitle) => {
    const warningId = randomHashGenerator(10);
    return SESSION + sessionId + "/" + WARNINGS + "/" + warningTitle.replace(" ", "") + "-" + warningId;
};
